module.exports = __webpack_public_path__ + "static/media/Artboard4.fc8ed4e2.png";